import { useState, useEffect, Fragment } from "react";
import FleetWebApi from "../Api/FleetWebApi";
import CircularProgress from "@mui/material/CircularProgress";
import FleetFwChart from "./FleetFwChart";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import Grid from "@mui/material/Grid";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import moment from "moment";
import TextField from "@mui/material/TextField";
import OnlineArchiveWarning, {
  isInOnlineArchive,
  useOnlineArchiveConfirm,
} from "./OnlineArchiveWarning";
function FleetStatusOffline(props) {
  const [report, setReport] = useState({});
  const [reports, setReports] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [reportDate, setReportDate] = useState(new Date());
  const [reportType, setReportType] = useState("");
  const [reportTimestamp, setReportTimestamp] = useState(null);
  const { confirmDateChange, archiveDialog } = useOnlineArchiveConfirm();
  // Dates older than the archive cutoff only apply after the user confirms the archive query
  const handleDateChange = (date) => {
    confirmDateChange(date, setReportDate);
  };
  const handleReportChange = (event) => {
    setReportType(event.target.value);
    setReportTimestamp(
      reports.find((obj) => obj.type === event.target.value).timestamp
    );
  };
  useEffect(() => {
    setIsLoading(true);
    setReportType("");
    setReports([]);
    setReport({});
    setError(null);
    // Archived dates only get here after the user confirmed the archive prompt
    FleetWebApi.getOfflineFleetStatusReportTypesByDay(
      Math.floor(reportDate.getTime() / 1000),
      isInOnlineArchive(reportDate)
    )
      .then((response) => {
        setReports(response);
      })
      .catch((error) => {
        setError(error.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [reportDate]);

  useEffect(() => {
    if (reportType !== "") {
      setReport({});
      setIsLoading(true);
      setError(null);
      FleetWebApi.getFleetStatusReport(reportDate, reportType, isInOnlineArchive(reportDate))
        .then((response) => {
          setReport(response);
        })
        .catch((error) => {
          setError(error.message);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, [reportType]);

  return (
    <Fragment>
      <h1>Fleet Status Report (Offline)</h1>

      <Grid container spacing={2}>
        <Grid item xs={12} md={12} lg={6}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              disableToolbar
              variant="inline"
              format="MM/dd/yyyy"
              margin="normal"
              id="date-picker-inline"
              label="Start Date"
              value={reportDate}
              onChange={handleDateChange}
              KeyboardButtonProps={{
                "aria-label": "change date",
              }}
              renderInput={(params) => <TextField {...params} />}
            />
          </LocalizationProvider>
          <OnlineArchiveWarning date={reportDate} />
          {archiveDialog}
        </Grid>

        <Grid item xs={12} md={12} lg={6} key={"gridItemTypeMenu"}>
          <FormControl
            disabled={!reports || reports.length === 0 ? true : false}
            fullWidth
          >
            <InputLabel id="chart-select-label">Report Type</InputLabel>
            <Select
              labelId="device-select-label"
              id="device-select"
              value={reportType}
              label="reportType"
              onChange={(event) => handleReportChange(event)}
            >
              {Object.keys(reports).map((report, reportIndex) => (
                <MenuItem value={reports[reportIndex].type} key={reportIndex}>
                  {moment(reports[reportIndex].timestamp).format("YYYY-MM-DD") +
                    " " +
                    reports[reportIndex].type.split("-")[2]}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      </Grid>
      {error && <p>Error Loading Data: {error}</p>}
      {!error && isLoading && <CircularProgress color="secondary" />}
      {!error &&
        !isLoading &&
        Object.keys(report).length !== 0 &&
        report.fw_data.length !== 0 && (
          <FleetFwChart
            data={report}
            deviceType={reportType}
            reportDate={reportTimestamp}
          />
        )}
      {!error &&
        !isLoading &&
        Object.keys(report).length !== 0 &&
        report.fw_data.length === 0 && <h3>No devices in this subset</h3>}
    </Fragment>
  );
}

export default FleetStatusOffline;
